<template>
  <reminder-table resource-name="project" :resource-id="projectData.id" @refetch-data="emit('refetch-data')" />
</template>

<script>
import { useState } from 'vuex-composition-helpers'
import ReminderTable from '@/components/reminders-table/ReminderTable.vue'

export default {
  components: { ReminderTable },
  setup(props, { emit }) {
    const { projectData } = useState('staff', ['projectData'])

    return {
      emit,
      projectData,
    }
  },
}
</script>
